import * as Icon from '@mui/icons-material/';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Column } from '../pages/Components/Table/Types';
import { ReajusteEstoqueCadastrar } from '../routes/RoutesNames';
import ReajusteEstoqueController from '../controllers/ReajusteEstoqueController';
import { ButtonMenu } from '../shared/components/ButtonMenu';
import { toast } from 'react-toastify';

interface Row {
    est_id: number;
    est_dataInc: string;
    prod_id: number;
    prod_descricao: string;
    est_qtdAtual: number;
    est_qtdReal: number;
    est_diferenca: number;
    est_ocorrencia: string;
    est_status: string;
    est_dataAlt: string;
    est_dataBaixa: string;
}

const useReajusteEstoquePesquisar = () => {

    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const [tableRows, setTableRows] = useState<Row[]>([]);

    const initialValues = {
        est_id: '',
        prod_descricao: '',
        est_dataInicial: null,
        est_dataFinal: null,
        est_status: '',
        responsavel: ''
    }

    const tableColumns: Column[] = ([
        { id: 'est_id', label: 'est_id', minWidth: 0, align: 'center', hidden: true, maxWidth: undefined },
        { id: 'est_dataInc', label: 'Data/Hora', minWidth: 0, align: 'center', maxWidth: undefined },
        { id: 'prod_id', label: 'Produto', minWidth: 0, align: 'center', maxWidth: undefined },
        { id: 'prod_descricao', label: 'Descrição do Produto', minWidth: 0, maxWidth: undefined },
        { id: 'est_qtdAtual', label: 'Qtd.Estoque', minWidth: 0, align: 'center', maxWidth: undefined },
        { id: 'est_qtdReal', label: 'Qtd.Real', minWidth: 0, hidden: true, align: 'center', maxWidth: undefined },
        { id: 'est_diferenca', label: 'Diferença', minWidth: 0, hidden: true, align: 'center', maxWidth: undefined },
        { id: 'est_ocorrencia', label: 'Ocorrência', minWidth: 0, align: 'center', maxWidth: undefined },
        { id: 'est_status', label: 'Status', minWidth: 0, align: 'center', maxWidth: undefined },
        { id: 'est_dataAlt', label: 'Data Alt', minWidth: 0, align: 'center', maxWidth: undefined },
        { id: 'est_dataBaixa', label: 'Data Baixa', minWidth: 0, align: 'center', maxWidth: undefined },
        { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right', maxWidth: undefined },
    ]);

    const fields = [
        { name: 'est_id', type: 'text', label: 'Código' },
        { name: 'prod_descricao', type: 'text', label: 'Produto' },
        { name: 'responsavel', type: 'text', label: 'Responsável' },
        { name: 'est_status', type: 'text', label: 'Status' },
        { name: 'est_dataInicial', type: 'date', label: 'Data Início', col: 2 },
        { name: 'est_dataFinal', type: 'date', label: 'Data Final', col: 2 },
        { type: 'submit', icon: (<Icon.Search style={{ fontSize: '28px' }} />) }
    ]

    const handleNavigation = async (): Promise<void> => {
        navigate(ReajusteEstoqueCadastrar)
    }

    const handleSubmit = async (values: any) => {
        setLoading(true)

        const request = {
            est_id: values.est_id,
            prod_descricao: values.prod_descricao,
            dataInicial: values.est_dataInicial,
            dataFinal: values.est_dataFinal,
            est_status: values.est_status,
            responsavel: values.responsavel
        }
        console.log('Request:', request);
        const DataRows: any = [];
        const Response: any = await ReajusteEstoqueController.Listar(request);

        if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
            Response.Data.map((item: Row) => {
                DataRows.push({
                    est_id: item.est_id,
                    est_dataInc: item.est_dataInc,
                    prod_id: item.prod_id,
                    prod_descricao: item.prod_descricao,
                    est_qtdAtual: item.est_qtdAtual,
                    est_qtdReal: item.est_qtdReal,
                    est_diferenca: item.est_diferenca,
                    est_ocorrencia: item.est_ocorrencia,
                    est_status: item.est_status,
                    est_dataAlt: item.est_dataAlt,
                    est_dataBaixa: item.est_dataBaixa,
                    BtnMenu: (
                        <ButtonMenu
                            items={[
                                { onClick: () => handleStockOut(item.est_id, 'BAIXADO'), menu: 'Baixar' },
                                { onClick: () => handleStockOut(item.est_id, 'CANCELADO'), menu: 'Cancelar' },
                            ]}
                        />
                    ),
                });

                setTableRows(DataRows);
            });
        } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
            toast.info('Nenhum registro encontrado!', {
                type: 'error',
            });
            setTableRows([]);
        } else {
            toast.error('Ocorreu um erro ao buscar os registros!', {
                type: 'error',
            });
            setTableRows([]);
        }

        setLoading(false);
    };


    const handleStockOut = async (id: number, status: string) => {
        setLoading(true);

        const request = { est_id: id, est_status: status };
        const Response: any = await ReajusteEstoqueController.Baixar(request);
        if (Response.StatusCode === 200) {
            if (status === 'Baixado') {
                toast.info('Estoque baixado com sucesso!', {
                    type: 'success',
                });
            } else {
                toast.info('Reajuste cancelado com sucesso!', {
                    type: 'success',
                });
            }
            handleSubmit(initialValues);
        } else {
            toast.error('Ocorreu um erro ao baixar o estoque!', {
                type: 'error',
            });
        }
        setLoading(false);
    }

    useEffect(() => {
        handleSubmit(initialValues);
    }, []);

    return {
        initialValues,
        loading,
        fields,
        tableColumns,
        tableRows,
        handleNavigation,
        handleSubmit
    };
}

export default useReajusteEstoquePesquisar;